/*
 * Copyright (c) Nexign, JSC, 2019-2023.
 */
/**
 *
 *
 * @author Evgenij Tyan
 * @author Aleksandr Perkhunov
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.0.0
 */

import get from 'lodash/get';
import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { requestSaga } from '@/main/sagas/requestSaga';
import { API_HOSTNAME, FIELDS, FIELDS_SIZE } from '@modules/app/Api';

import { loadTableFieldsError, loadTableFieldsSuccessful, loadTableMeta } from '../actions/tableActions';
import { makeSelectorBasketContext } from '../selectors/tableSelectors';
import { MapTableNameToApiPath } from '../types/tableMapTypes';
import { TableNameType } from '../types/tableTypes';
import type { ISendTableFieldsPayload, ISendTableFieldsSizePayload } from '../types/tableTypes';

const SendFailError = (tableName: TableNameType) => `server didn't set fields for ${tableName}`;

/**
 * @description sendUserCache function iterator, required to obtain a user cache.
 * @return {SagaIterator}
 */
export function* sendTableFieldsSagas(action: { payload: ISendTableFieldsPayload; type: string }): SagaIterator {

    const tableName = action.payload.tableName;
    const fields = action.payload.fields;
    const context = yield select(makeSelectorBasketContext());
    const queryParams = { context };

    const URL = API_HOSTNAME + MapTableNameToApiPath[tableName] + FIELDS;

    try {
        const tableData = yield call(requestSaga, URL, 'POST', { fields });
        const fieldsResponse = get(tableData, 'fieldSettings.fields', []);
        if (fieldsResponse) {
            yield put(loadTableFieldsSuccessful({ fields: fieldsResponse }));
        } else {
            yield put(loadTableFieldsError({ error: SendFailError(tableName) }));
        }
        yield put(loadTableMeta({ force: true, tableName, queryParams }));
    } catch (error: any) {
        yield put(loadTableFieldsError({ error }));
    }
}

export function* sendTableFieldsSizeSaga(action: { payload: ISendTableFieldsSizePayload; type: string }): SagaIterator {

    const tableName = action.payload.tableName;
    const fields = action.payload.fields;

    const URL = API_HOSTNAME + MapTableNameToApiPath[tableName] + FIELDS_SIZE;

    try {
        yield call(requestSaga, URL, 'POST', { fields });
    } catch (error: any) {
        yield put(loadTableFieldsError({ error }));
    }
}
